<template>
	<div
		class="tooltip-msg"
		:style="widthMsg && { width: widthMsg }"
		role="tooltip"
	>
		<div v-if="pointer" class="tooltip-pointer"></div>
		<div class="body-text-1">
			<slot></slot>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		pointer: {
			type: Boolean,
			default: true
		},
		widthMsg: {
			type: String,
			default: ''
		}
	}
};
</script>
<style lang="scss" scoped>
.tooltip-msg {
	position: absolute;
	width: 200px;
	padding: 16px;
	border-radius: 8px;
	box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);
	z-index: 9;
	border: 1px solid $container-border;
	background-color: $container-bgcolor;

	&.top {
		.tooltip-pointer {
			right: 24px;
			top: -8px;
			border-left: 1px solid $container-border;
			border-top: 1px solid $container-border;
		}
		&.center {
			.tooltip-pointer {
				left: 0;
				right: 0;
				margin: auto;
			}
		}
	}

	&.left {
		.tooltip-pointer {
			top: 0;
			bottom: 0;
			left: -8px;
			margin: auto;
			border-left: 1px solid $container-border;
			border-bottom: 1px solid $container-border;
		}
	}

	&.right {
		.tooltip-pointer {
			top: 0;
			bottom: 0;
			right: -8px;
			margin: auto;
			border-right: 1px solid $container-border;
			border-top: 1px solid $container-border;
		}
	}

	&.bottom {
		.tooltip-pointer {
			bottom: -8px;
			border-right: 1px solid $container-border;
			border-bottom: 1px solid $container-border;
		}
	}

	.tooltip-pointer {
		width: 16px;
		height: 16px;
		transform: rotate(45deg);
		position: absolute;
		background-color: $container-bgcolor;
	}
}
</style>
